import React from "react";
import "./styles.scss";

import { MdCheck } from "react-icons/md";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import {
  useWorkShop,
  WorkshopSection,
} from "../../../../contexts/workshop-context/WorkshopContext";
import CustomMenu from "../../../../shared/components/CustomMenu/CustomMenu";
import { zeroPad } from "../../../../shared/utils/Commons";
import { SubsectionStatus } from "../../../../contexts/user-context/UserContext";
// import moment from "moment";
const SideBar = () => {
  const workshop = useWorkShop();
  const { push } = useHistory();

  return (
    <div className="public-workshop-side-bar-wrapper">
      <div className="title" style={{ maxWidth: "300px" }}>
        <div className="back-button" style={{ transform: "translateX(6px)" }}>
          <HiArrowNarrowLeft onClick={() => push("/publiclibrary")} />
        </div>
        <div>
          <h4
            className="text-left multi-line-truncate"
            style={{
              maxWidth: "280px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            {workshop.title}
          </h4>
        </div>
      </div>

      <div className="menu">
        <CustomMenu
          data={[
            {
              text: "Summary",
              onClick: () => {
                workshop.setSelectedSubSection({
                  ...workshop.selectedSubSection,
                  orderNo: -1,
                });
              },
              isActive: workshop.selectedSubSection.orderNo === -1,
            },
          ]}
        />
        <SubsectionsMenu />
      </div>
    </div>
  );
};

const SubsectionsMenu = () => {
  const workshop = useWorkShop();
  return (
    <div className="subsections-menu-wrapper">
      <ul>
        {workshop.workshopSections.map((sub, index) => (
          <SubsectionMenuItem
            key={index}
            title={`${zeroPad(index + 1, 2)}. ${sub.subSectionTitle}`}
            completed={sub.status === SubsectionStatus.DONE}
            workshopId={workshop.id}
            subsection={sub}
          />
        ))}
      </ul>
    </div>
  );
};

interface IPropsSMI {
  completed?: boolean;
  title: string;
  workshopId: string;
  subsection: WorkshopSection;
}

const SubsectionMenuItem = (props: IPropsSMI) => {
  const workshop = useWorkShop();
  return (
    <li
      onClick={() => {
        workshop.setSelectedSubSection(props.subsection);
      }}
      style={
        props.subsection.orderNo === workshop.selectedSubSection.orderNo
          ? { backgroundColor: "#006699" }
          : {}
      }
    >
      <div className="sub-title">{props.title}</div>
      <div className="sub-mark">
        {props.completed && (
          <span>
            <MdCheck />
          </span>
        )}
      </div>
    </li>
  );
};

export default SideBar;
